var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTeeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.74485 1.55993C4.31501 1.36889 3.83086 1.68353 3.83086 2.15391V10.2928C4.18071 10.2392 4.54828 10.1923 4.93086 10.1525V5.74404L8.77698 4.60444C9.35631 4.43279 9.40845 3.63264 8.85632 3.38725L4.74485 1.55993ZM7.29392 3.8966L4.93086 4.59677V2.84635L7.29392 3.8966Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93086 10.1525C4.54828 10.1923 4.18071 10.2392 3.83086 10.2928V11.305C4.17727 11.2492 4.54497 11.1999 4.93086 11.1581V10.1525Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4143 11.556C13.9868 11.6991 14.4175 11.8539 14.7102 12C14.4175 12.1461 13.9868 12.301 13.4143 12.4441C12.0667 12.781 10.152 13 8 13C5.848 13 3.93329 12.781 2.58568 12.4441C2.01319 12.301 1.58249 12.1461 1.28975 12C1.58249 11.8539 2.01319 11.6991 2.58568 11.556C2.95946 11.4625 3.37686 11.3781 3.83086 11.305V10.2928C1.53324 10.6442 0 11.2773 0 12C0 13.1046 3.58172 14 8 14C12.4183 14 16 13.1046 16 12C16 10.8955 12.4183 10 8 10C6.91265 10 5.87596 10.0543 4.93086 10.1525V11.1581C5.8626 11.0572 6.90032 11 8 11C10.152 11 12.0667 11.2191 13.4143 11.556ZM15.0651 11.7686C15.0651 11.7686 15.0628 11.7727 15.0551 11.7805C15.0607 11.7724 15.0651 11.7686 15.0651 11.7686ZM0.934919 11.7686C0.934919 11.7686 0.939311 11.7724 0.944911 11.7805C0.937189 11.7727 0.934919 11.7686 0.934919 11.7686ZM0.93492 12.2315C0.93492 12.2315 0.937189 12.2274 0.944912 12.2195C0.939311 12.2276 0.93492 12.2315 0.93492 12.2315ZM15.0551 12.2195C15.0628 12.2274 15.0651 12.2315 15.0651 12.2315C15.0651 12.2315 15.0607 12.2276 15.0551 12.2195Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38086 12.55C4.68462 12.55 4.93086 12.3038 4.93086 12V11.1581C4.54497 11.1999 4.17727 11.2492 3.83086 11.305V12C3.83086 12.3038 4.0771 12.55 4.38086 12.55Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTeeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TeeIcon.7e5617a764711a32e752717dc2ac6219.svg";